// src/seo/serviceAreas.js
// Perth-metro + surrounding suburbs Aeti services. Used to (a) list every area in the
// LocalBusiness structured data (public/index.html) so Google understands the full service area,
// and (b) render a real, single "Suburbs we service" list on the Contact page.
//
// Deliberately NOT used to generate one page per suburb — 20 near-identical location pages with
// only the place name swapped are exactly the kind of thin "doorway" pages Google's guidelines
// warn against. One well-optimised set of pages (Home, Services, Contact) naming every suburb
// once concentrates ranking signal instead of diluting it.
export const serviceAreas = {
  perth: { name: "Perth", slug: "perth" },
  perthCBD: { name: "Perth CBD", slug: "perth-cbd" },
  beckenham: { name: "Beckenham", slug: "beckenham" },
  cannington: { name: "Cannington", slug: "cannington" },
  bentley: { name: "Bentley", slug: "bentley" },
  queensPark: { name: "Queens Park", slug: "queens-park" },
  victoriaPark: { name: "Victoria Park", slug: "victoria-park" },
  willetton: { name: "Willetton", slug: "willetton" },
  bullCreek: { name: "Bull Creek", slug: "bull-creek" },
  eastPerth: { name: "East Perth", slug: "east-perth" },
  mountLawley: { name: "Mount Lawley", slug: "mount-lawley" },
  scarborough: { name: "Scarborough", slug: "scarborough" },
  joondalup: { name: "Joondalup", slug: "joondalup" },
  butler: { name: "Butler", slug: "butler" },
  yanchep: { name: "Yanchep", slug: "yanchep" },
  rockingham: { name: "Rockingham", slug: "rockingham" },
  mandurah: { name: "Mandurah", slug: "mandurah" },
  pinjarra: { name: "Pinjarra", slug: "pinjarra" },
  bunbury: { name: "Bunbury", slug: "bunbury" },
  busselton: { name: "Busselton", slug: "busselton" },
};

export const serviceAreaList = Object.values(serviceAreas);
